import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind class merge — shadcn/ui pattern */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Türkçe para birimi formatı */
export function formatTRY(amount: number | string): string {
  const n = typeof amount === 'string' ? Number(amount) : amount;
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    maximumFractionDigits: 0,
  }).format(n);
}

/** Türkçe tarih formatı */
export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

/** Göreceli zaman: "3 saat önce" */
export function formatRelative(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const diff = (Date.now() - d.getTime()) / 1000;

  const rtf = new Intl.RelativeTimeFormat('tr', { numeric: 'auto' });
  if (diff < 60) return rtf.format(-Math.floor(diff), 'second');
  if (diff < 3600) return rtf.format(-Math.floor(diff / 60), 'minute');
  if (diff < 86400) return rtf.format(-Math.floor(diff / 3600), 'hour');
  if (diff < 2592000) return rtf.format(-Math.floor(diff / 86400), 'day');
  if (diff < 31536000) return rtf.format(-Math.floor(diff / 2592000), 'month');
  return rtf.format(-Math.floor(diff / 31536000), 'year');
}

/** Telefon numarasını Türkçe formatlı göster: 0(555) 111 22 33 */
export function formatTelefon(tel: string | null | undefined): string {
  if (!tel) return '';
  const digits = tel.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('0')) {
    return `${digits.slice(0, 1)}(${digits.slice(1, 4)}) ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`;
  }
  if (digits.length === 10) {
    return `0(${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`;
  }
  return tel;
}

/** `tel:` linki için E.164 benzeri sade form (sadece rakam + opsiyonel + prefiks).
 *  10 hanesi olanın başına 0 ekler. Boşsa null döner. */
export function telHref(tel: string | null | undefined): string | null {
  if (!tel) return null;
  const trimmed = tel.trim();
  const plus = trimmed.startsWith('+');
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return null;
  if (plus) return `tel:+${digits}`;
  if (digits.length === 10) return `tel:0${digits}`;
  return `tel:${digits}`;
}

/** İlk harflerden avatar — Ahmet Yılmaz → AY */
export function bashHarfler(ad: string, soyad?: string | null): string {
  const a = ad?.charAt(0)?.toUpperCase() ?? '';
  const s = soyad?.charAt(0)?.toUpperCase() ?? '';
  return (a + s).slice(0, 2);
}
